import { Participant } from 'livekit-client';
import { ChatButton } from 'features/Room/components';
import { ParticipantsCount } from 'features/Modals/ParticipantsModal';
import { RecordPanel } from 'features/Recording';
import { SummaryPanel } from 'features/Summary';
import { Badge } from '../../../components/Badge/Badge';
import { MobileButtons, MobileTopbar } from './view';

interface Props {
    participants: Participant[];
}

export const Toolbar: React.FC<Props> = ({ participants }) => {
    return (
        <MobileTopbar>
            <Badge />
            <MobileButtons>
                <SummaryPanel isMobile />
                <RecordPanel buttonShape="rectangle" buttonSize="small" />
                <ChatButton />
                <ParticipantsCount count={participants.length} />
            </MobileButtons>
        </MobileTopbar>
    );
};
